export default __webpack_public_path__ + "static/media/MBRobosto.b76bac2e.png";